import React from 'react'
import DocumentTitle from 'react-document-title'
import GISMap from '_/shared/components/gisMap'

/**
 * GIS
 */
class GIS extends React.Component {
  static contextTypes = {
    router: React.PropTypes.func
  }

  render() {
    const query = this.context.router.getCurrentQuery()

    return (
      <DocumentTitle title="GIS">
        <div>
          <GISMap
            county={query.county}
            pin={query.pin}
          />
        </div>
      </DocumentTitle>
    )
  }
}

export default GIS



// WEBPACK FOOTER //
// ./modules/shared/pages/gis.js